var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M31.439 8A2.57 2.57 0 0134 10.58v26.84A2.57 2.57 0 0131.439 40H15.561A2.57 2.57 0 0113 37.42V10.58A2.57 2.57 0 0115.561 8h15.878zm-13.317 2.065h-1.537c-.818 0-1.487.644-1.534 1.457l-.002.09v24.775c0 .825.64 1.499 1.446 1.546l.09.002h13.83c.818 0 1.487-.644 1.534-1.457l.002-.09V11.612c0-.825-.64-1.499-1.446-1.546l-.09-.002h-2.02l-.213.99a1.54 1.54 0 01-1.502 1.221h-6.79c-.694 0-1.303-.47-1.483-1.145l-.285-1.066zM29.57 23.302c.212.195.332.47.332.758v10.263c0 .855-.693 1.548-1.548 1.548h-9.429a1.032 1.032 0 01-.758-1.732l9.945-10.779a1.032 1.032 0 011.458-.058z", fill: "currentColor", fillRule: "nonzero" }))));
});
